import React from 'react';
import Contact from './Contact';



export default function Image() {
  return (
    <>
    <div className='homepage'>
   <header>
   
    <div className='row'>


    <div className='col-lg-6 col-md-6 col-xs-6 col-sm-6'>
        <div className="container">
  <div className="row-head">
  <div class="name-head">
      <h1 className='name animate__animated animate__bounce' >Hi👋,I'm Mussafara Riaz 👧 </h1>
  
    </div>
    

    <h1 className='desg animate__animated  animate__heartBeat' >Front End Developer</h1>
    
  </div>

           
        
            </div>
            </div>
       
       <div className='col-lg-5 col-md-2 col-xs-6 col-sm-6'>
            <div className="boxdiv">
               <img src="pr.png" alt="" />
            </div>

        </div>
       

           
            
        </div>
        </header>
        <div id="introduction">
        <div id="text">
            <h1 id="abt-head" className='animate-charcter'>Let Me Introduce My Self</h1>
            <p>Hello Everyone, My name is Mussafara Riaz currently student of Software Engineering at NED university
                My area of interest is Web and mobile application development , Machine learning and cloud computing
                Apart from coding some other activities I love to do

                <li>Public Speaking</li>
                <li>Writing</li>
                <li>Reading</li>
                <li>Drawing</li>
             </p>

        </div>
        <div id="side-img">
            <img src="https://media.istockphoto.com/vectors/cheerful-female-enjoying-time-on-social-media-blogger-creative-people-vector-id1224664031?k=20&m=1224664031&s=612x612&w=0&h=vvhYzQhq00sMs-K5xnw0BisZJs1TJyKlf2Zpk0nG4Xo=" alt=""/>
          
        </div>
       
       </div>
       <Contact/>
       </div>
       
       </>

  )
}